import React, { useState } from 'react';
import axios from 'axios';
import './Contact.css';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const Contact = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    message: '',
    areaCode: '',
    phoneNumber: '',
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const validateInputs = () => {
    const { name, email, message, areaCode, phoneNumber } = formData;
    if (!name || !email || !message || !areaCode || !phoneNumber) {
      toast.error('Todos los campos son obligatorios');
      return false;
    }
    if (!/^\S+@\S+\.\S+$/.test(email)) {
      toast.error('Correo electrónico no válido');
      return false;
    }
    if (!/^\d{2,4}$/.test(areaCode)) {
      toast.error('Código de área no válido');
      return false;
    }
    if (!/^\d{7,10}$/.test(phoneNumber)) {
      toast.error('Número de teléfono no válido');
      return false;
    }
    return true;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validateInputs()) return;

    try {
      const response = await axios.post(
        'https://portfolio-o8kd.onrender.com/send',
        formData
      );
      toast.success('Email enviado exitosamente');
      console.log('Email sent successfully:', response.data);
    } catch (error) {
      toast.error('Error al enviar el email');
      console.error('Error sending email:', error);
    }
  };

  return (
    <div className="contact__container">
      <ToastContainer />
      <div className="contact__left">
        <form onSubmit={handleSubmit} className="contact__form">
          <div className="form__input">
            <label htmlFor="name" className="title__input">
              Nombre
            </label>
            <input
              type="text"
              name="name"
              id="name"
              className="box__input"
              value={formData.name}
              onChange={handleChange}
            />
          </div>
          <div className="form__input">
            <label htmlFor="email" className="title__input">
              Correo Electrónico
            </label>
            <input
              type="text"
              name="email"
              id="email"
              className="box__input"
              value={formData.email}
              onChange={handleChange}
            />
          </div>
          <div className="form__row">
            <div className="form__input area-width">
              <label htmlFor="areaCode" className="title__input">
                Cód.
              </label>
              <input
                type="text"
                name="areaCode"
                id="areaCode"
                className="box__input input-area"
                value={formData.areaCode}
                onChange={handleChange}
              />
            </div>
            <div className="form__input">
              <label htmlFor="phoneNumber" className="title__input">
                Número de Teléfono
              </label>
              <input
                type="text"
                name="phoneNumber"
                id="phoneNumber"
                className="box__input"
                value={formData.phoneNumber}
                onChange={handleChange}
              />
            </div>
          </div>
          <div className="form__input">
            <label htmlFor="message" className="title__input">
              Mensaje
            </label>
            <textarea
              name="message"
              id="message"
              rows={10}
              cols={50}
              className="message__input"
              value={formData.message}
              onChange={handleChange}
            ></textarea>
          </div>
          <button type="submit" className="btn__form">
            Enviar
          </button>
        </form>
      </div>
      <div className="contact__right">
        <h1 className="right__title">Contacto</h1>
        <p className="right__description">
          Es muy importante para nosotros mantenernos en contacto con usted, por
          eso siempre estamos listos para responder cualquier pregunta que le
          interese.
        </p>
      </div>
    </div>
  );
};

export default Contact;
